export type BulkUpdateTicketsOfIfAttributeDesignReviewRequest = {
  ifAttrDsgnRvwList: IfAttrDsgnRvw[];
  evntGrpTypeCd: string;
  dfnSetVerNum: string;
};
export type IfAttrDsgnRvw = {
  index: Number;
  tcktId: string;
  tcktStsTypeCd: string;
  ifReqId: string;
  dipByRgn: string;
  cpntId: string;
  cmnt?: string;
  updateDateTime?: string;
};
